import React from 'react';
import { connect } from 'react-redux';
import { langTexts } from './locals';

import './index.css';

const SanferRedText = (props) => {
  const { lang } = props.settings,
    texts = langTexts[lang],
    { text = texts.title } = props;

  return (
    <div className='sanfer-text transition'>
      <span className='transition'>{text}</span>
    </div>
  );
};

const mapStateToProps = (state) => ({
  settings: state.settings,
});

export default connect(mapStateToProps)(SanferRedText);
